import React from "react";
import Hero from "../components/hero/Hero";
// import Welcome from "../components/welcome/Welcome";
import Services from "../components/services/Services";
import Footer from "../components/footer/Footer";
import About from "../components/about/About";

function Home() {
  return (
    <div>
      <Hero />
      {/* <Welcome /> */}
      <About />
      <Services />
      <Footer />
    </div>
  );
}

export default Home;
